import { routePath } from "../../routes/routePath";

export const pageInfoLink = {
  root: [
    { name: "ホームページ", url: routePath.homepage },
    { name: "リンク集", url: routePath.link },
  ],
  pageHeader: "リンク集",
};
